import { KineduPalette } from 'kinedu-react-components';
import { Tooltip } from 'lego-dist';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { sendReportEmail } from '../../lib/utils';

interface ReportButtonProps {}

const ComponentWrapper = styled.a`
  position: fixed;
  bottom: 8px;
  right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  font-size: 16px;
  border: 1px solid ${KineduPalette.shadeMedium};
  border-radius: 100px;
  background: white;
  box-shadow: 0px 0px 10px -4px ${KineduPalette.shadeMedium};

  transition: all 0.5s;
  cursor: pointer;
  z-index: 10;

  :hover {
    width: 40px;
    height: 40px;
  }

  .tooltip-report-button {
    border: none;

    div {
      font-size: 16px;
      left: -153px;
      text-align: center;
      &:before, &:after {
        left: 130px;
        top: 10%;
        transform: rotate(60deg);
      }
      &:after {
        left: 128px;
      }
    }
  }
`;

const ReportButton: React.FC<ReportButtonProps> = () => {
  const { t } = useTranslation();
  return (
    <ComponentWrapper
      className="report-button"
      href={sendReportEmail(t, 'EMAIL_MSG.SUBJECT', 'EMAIL_MSG.BODY1')}
    >
      <Tooltip
        classNames="tooltip-report-button"
        text={t('REPORT_BUG')}
        color={KineduPalette.shadeMediumLight}
        colorText={KineduPalette.shadeDarker}
        iconColor={KineduPalette.shadeMedium}
        bgColor="white"
        icon="exclamation"
        width="28px"
        widthContent="135px"
      />
    </ComponentWrapper>
  );
};

export default ReportButton;
